import Questionnaire from '@/modules/QuestionnaireBanner';
import { useTheme } from '@material-ui/core/styles';
import React, { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

const AppLayout = lazy(() => import(`globalcomponents/Layouts/Base`));
const Loader = require(`globalcomponents/Loader`).default;

const RenderComponent = ({ setAuth, config, folderPath, setFilterPopup, ...rest }) => {
  const history = useHistory();
  const i18n = useTranslation();
  const theme = useTheme();

  const AsyncComponent = lazy(() => {
    return import(`@/pages${folderPath}${config.component}`);
  });

  return (
    <Suspense fallback={<Loader />}>
      <Questionnaire />
      <AppLayout
        setAuth={setAuth}
        pageTitle={config.title}
        layout={config.layout}
        showFilterPopup={setFilterPopup}
        folderPath={folderPath}
        i18n={i18n}
      >
        <AsyncComponent
          {...rest}
          module={config.module}
          showFilterPopup={setFilterPopup}
          history={history}
          i18n={i18n}
          theme={theme}
        />
      </AppLayout>
    </Suspense>
  );
};

export default RenderComponent;
